// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-details__info[data-v-7a39d61d]{text-align:left}.error-details__info[data-v-7a39d61d] a{color:#a363ff}@media (max-width:767px){.error-details__info[data-v-7a39d61d]{width:100%}}.error__block_contact[data-v-7a39d61d]{width:100%}.error-details__divider[data-v-7a39d61d]{width:100%;height:1px;background:#d6d4d8;margin:32px 0}@media (max-width:767px){.error-details__divider[data-v-7a39d61d]{margin:24px 0}}", ""]);
// Exports
module.exports = exports;
